const getClassName = base => (component, modifier) =>
  [base, component, modifier ? `-${modifier}` : null].filter(Boolean).join('-');

export default getClassName;
